module.exports = __webpack_public_path__ + "img/join4-3.ea08f007.svg";